import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  public localeEvent = new Subject<string>();

  /**
   * @constructor
   * @param { TranslateService } _translate
   * @param { LocalStorageService } _localStorage
   */
  constructor(
    private _translate: TranslateService,
    private _localStorage: LocalStorageService
  ) { }

  /**
   * Permite cambiar el idioma del aplicativo
   * @param { string } locale
   * @return { void }
   */
  public changeLocale( locale: string): void {
    this._translate.use(locale);
    this.localeEvent.next(locale);
  }

  /**
   * Configura idioma dependiendo el caso
   * @return { void }
   */
  public setLanguage(): void {
    const isLanguageSaved: boolean = ('language' in localStorage);
    if (!isLanguageSaved) {
      const BrowserLanguage: string = this._translate.getBrowserLang();
      this._translate.use(BrowserLanguage);
      this._localStorage.setItem('language', BrowserLanguage);
    } else {
      const Language: string = this._localStorage.getItem('language');
      this._translate.setDefaultLang(Language);
    }
  }

}